// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f02a0ea7","160":"c07172f5","208":"4d419b4e","293":"9d7c4793","453":"5d79306b","516":"24793501","519":"b9f7d1b2","917":"eeebfa71","946":"baa8be2d"}[chunkId] + ".chunk.js";
};